export const environment = {
  /**
   * BOTON DE PANICO en el menu.
   *
   * false = la pantalla existe y se llega escribiendo la URL, pero NO aparece en
   * el menu de nadie. Es lo que permite desplegar la web con el modulo dentro
   * mientras se termina de probar, sin que a un cliente le aparezca una opcion a
   * medio terminar.
   *
   * Se pone en true recien cuando el flujo completo este validado en produccion.
   *
   * Ojo: esto es SOLO visibilidad del menu. Quien puede entrar de verdad lo
   * decide el permiso PermisosModulos.BotonPanico -que nace apagado- y el
   * backend, que lo vuelve a comprobar en cada endpoint.
   */
  botonPanicoEnMenu: true,

  //rutaApi: 'http://localhost:2037/api/',
  rutaApi: 'https://admin.controlguard.cl/api/',
  rutaApiMovil: 'https://controlguard.cl:3090/api/',
  _baseUrl: 'https://controlguard.cl/facturacion/dtes/',
  production: false
};
